import { render, staticRenderFns } from "./SwitchUserModal.vue?vue&type=template&id=34c1d05e&scoped=true&"
import script from "./SwitchUserModal.vue?vue&type=script&lang=js&"
export * from "./SwitchUserModal.vue?vue&type=script&lang=js&"
import style0 from "./SwitchUserModal.vue?vue&type=style&index=0&id=34c1d05e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34c1d05e",
  null
  
)

export default component.exports